import React, { ChangeEventHandler } from "react";

type RadioProps = {
  checked: boolean;
  handleCheck: ChangeEventHandler<HTMLInputElement>;
};

const Radio = ({ checked, handleCheck }: RadioProps) => {
  // @ts-ignore
  return (
    <label htmlFor="entrance">
      <input
        type="radio"
        className="delivery_form--radio"
        onChange={handleCheck}
        checked={checked}
      />
    </label>
  );
};

export default Radio;
